import axios from 'axios';
import { logoutLocalStorage } from './commonUtil';
import { endpoints } from 'endpoints/endpoints';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
    // 'x-user-type': 'POC',
    // 'x-org-type': 'SuperAdmin'
  }
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (window.localStorage) {
      const token = localStorage.getItem('userJwtToken');
      // const token =
      //   eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9
      //     .eyJpZCI6IjY3N2U2OGJkOTY3YzE1ZjdhYzE1MzA3YiIsInR5cGVzIjpbIk1haW4gUE9DIiwiU2Vjb25kYXJ5IFBPQyJdLCJvcmdhbml6YXRpb25UeXBlcyI6WyJTdXBlckFkbWluIiwiRW50ZXJwcmlzZSIsIlJlY3ljbGVyIiwiUmV0YWlsZXIiLCJSZXNlbGxlciIsIlNlcnZpY2VQcm92aWRlciJdLCJpYXQiOjE3NDQ2MTkyMDMsImV4cCI6MTc3NjE3NjgwM30
      //     .uF8HmRmtIYttXii6PURhF6oxjffaKcAS2uKRlJVF0CQ;
      const organizationType = localStorage.getItem('orgType');
      const usersType = localStorage.getItem('userType');

      // if (token && !config.skipAuth) {
      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
        // Access Redux state

        // Add custom headers
        // config.headers['x-user-type'] = usersType === 'Main POC' ? 'POC' : 'POC';
        config.headers['x-user-type'] = usersType === 'Main POC' || usersType === 'Secondary POC' ? 'POC' : usersType.replace(' ', '');
        config.headers['x-org-type'] =
          organizationType === 'Service Provider'
            ? 'ServiceProvider'
            : organizationType !== 'Super Admin'
            ? organizationType
            : 'SuperAdmin';
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ⬇️ Refresh Token Logic
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response && error.response.status === 417 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         // const userData = localStorage.getItem('userData');
//         // if (!userData) throw new Error('User not found!');
//         // // const userDataObj = userData ? JSON.parse(userData) : null;
//         // const userDataObj = parseJsonSafe(userData);
//         // if (!userDataObj) throw new Error('User is not an object');

//         // const userId = userDataObj ? userDataObj?.id || null : null;
//         // if (!userId) throw new Error('User Id not found!');

//         // console.log('Refresh Token - userData :', userDataObj, ' | userId : ', userDataObj?.id);
//         const refreshResponse = await axiosInstance.post(
//           `${endpoints.sessions}/refresh-token`,
//           {}, // assuming POST with no body
//           { skipAuth: true } // if cookies are used
//           // { withCredentials: true } // if cookies are used
//         );

//         if (refreshResponse.status === 200 && refreshResponse.data?.data) {
//           const newToken = refreshResponse?.data?.data || null;
//           localStorage.setItem('userJwtToken', newToken);

//           // Update Authorization header and retry original request
//           originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
//           return axiosInstance(originalRequest);
//         }
//       } catch (refreshError) {
//         console.log('refreshError : ', refreshError);
//         // if (refreshError.response && refreshError.response.status === 407) {

//         // }
//         // Clear cookies (if necessary) and localStorage
//         logoutLocalStorage(); // Your existing logout logic
//         // window.location.href = '/login'; // Redirect to login
//         window.location.replace('/'); // Redirect to login

//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(newToken) {
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
}

function addRefreshSubscriber(callback) {
  refreshSubscribers.push(callback);
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // const { dispatch } = store;
    // Token expired
    if (error.response && error.response.status === 417 && !originalRequest._retry) {
      originalRequest._retry = true;
      // dispatch({ type: 'SET_LOADING_STATUS', payload: true });
      // Wait if another refresh is in progress
      if (isRefreshing) {
        return new Promise((resolve) => {
          addRefreshSubscriber((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            resolve(axiosInstance(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const refreshResponse = await axiosInstance.post(
          `${endpoints.sessions}/refresh-token`,
          {},
          { skipAuth: true } // or withCredentials if using cookies
        );

        if (refreshResponse.status === 200 && refreshResponse.data?.data) {
          const newToken = refreshResponse.data.data;
          localStorage.setItem('userJwtToken', newToken);
          axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + newToken;

          // Notify all queued requests
          onRefreshed(newToken);

          // Retry original failed request
          originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        console.log('refreshError : ', refreshError);
        logoutLocalStorage();
        localStorage.setItem('isRefreshExpired', 1);
        window.location.replace('/');
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
        // dispatch({ type: 'SET_LOADING_STATUS', payload: false });
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
